<template> 
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Add New Outbound" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <!-- <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button> -->
                        <h5 style="margin-left: 10px">Reference : {{ data.transport_order.transport_reference }}</h5>
                    </div>
                    <div class="flex items-center">
                        <vs-button color="warning" class="btn mb-4 md:mb-0 mr-1" @click="cancelEdit" v-show="editMode && data.transport_order.is_posted == 0">Cancel</vs-button>
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="editForm" v-show="!editMode && data.transport_order.is_posted == 0">Edit</vs-button>
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" v-show="editMode" :disabled="data.transport_order_details.length > 0 ? false : true">Save</vs-button>
                    </div>
                </div>
                <vs-tabs>
                    <vs-tab label="Details">
                        <div class="vx-row mt-6">
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        TRO ID*
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.id" disabled/>
                                        <vs-input class="w-full" :value="tro_param_id" v-show="false" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Reference *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.transport_reference" :disabled="disabled_self()"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Req. Del. Date *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <flat-pickr class="w-full" v-model="data.transport_order.req_del_date" :disabled="disabled_self()"/>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Order Type *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="orderTypeOptions" v-model="data.transport_order.order_type_id" label="order_type" :clearable="false" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Client ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="clientOptions" v-model="data.transport_order.client_id" label="name" @input="clientChange()" :clearable="false" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Origin *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <!--<v-select :options="customerOptions" v-model="data.transport_order.origin_id" label="name" @input="setOrigin()" :clearable="false" :disabled="disabled_self()"></v-select>-->
                                        <vs-input class="w-full" v-model="data.transport_order.origin" :disabled="disabled_self()" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Address *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.origin_1" :disabled="disabled_self()" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.origin_2" :disabled="disabled_self()" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Origin Area *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="areaOptions" v-model="data.transport_order.origin_area_id" label="subdistrict" @search="searchArea" :clearable="false" :disabled="!editMode"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Origin Sub Area
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="subAreaOptions" v-model="data.transport_order.origin_subarea_id" label="village" @search="searchSubArea" :clearable="true" :disabled="!editMode"></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Destination *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <!--<v-select :options="customerOptions" v-model="data.transport_order.destination_id" label="name" @input="setDestination()" :clearable="false" :disabled="disabled_self()"></v-select>-->
                                        <vs-input class="w-full" v-model="data.transport_order.destination" :disabled="disabled_self()" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Address *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.destination_1" :disabled="disabled_self()" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.destination_2" :disabled="disabled_self()" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Destination Area *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="destAreaOptions" v-model="data.transport_order.destination_area_id" label="subdistrict" @search="searchDestArea" :clearable="false" :disabled="!editMode"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Destination Sub Area
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="subDestAreaOptions" v-model="data.transport_order.destination_subarea_id" label="village" @search="searchDestSubArea" :clearable="true" :disabled="!editMode"></v-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Transport">
                        <div class="vx-row mt-6">
                            <div class="vx-col md:w-1/2 w-full">

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Transporter ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="transporterOption" v-model="data.transport_order.transporter_id" label="name" :reduce="transporter_id => transporter_id.id" @search="searchTransporter" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Service Type ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="serviceTypeOption" v-model="data.transport_order.service_type_id" label="service_type" :reduce="service_type_id => service_type_id.id" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Tracking Reference
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.tracking_reference" :disabled="true" />
                                    </div>
                                </div>
                              
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Payment Type
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="paymentTypeOption" v-model="data.transport_order.payment_type_id" label="payment_type" :reduce="payment_type_id => payment_type_id.id" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Currency
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="currencyOption" v-model="data.transport_order.currency_id" label="currency_code" :reduce="currency_id => currency_id.id" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Order Value
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.order_value" :disabled="disabled_self()" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Internal Notes">
                        <div class="vx-row mt-6">
                            <div class="vx-col w-full">
                                <vs-textarea v-model="data.transport_order.internal_notes" label="Internal Notes" height="200" :disabled="disabled_self()" />
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="External Notes">
                        <div class="vx-row mt-6">
                            <div class="vx-col w-full">
                                <vs-textarea v-model="data.transport_order.external_notes" label="External Notes" height="200" :disabled="disabled_self()" />
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Attachment">
                    </vs-tab>
                </vs-tabs>
            </vs-card>
            <vs-card class="p-4">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <h4>Transport Order Details</h4>
                    <vs-button @click="addItem()" class="btn mb-4 md:mb-0 mr-1" :disabled="disabled_self()">Add</vs-button>
                </div>
                <div style="overflow-y: auto;">
                    <table cellspacing="5">
                        <thead>
                            <tr>
                                <th style="width: 1%">Line ID</th>
                                <th style="width: 15%">Warehouse</th>
                                <th style="width: 15%">Product</th>
                                <th style="width: 10%">Description</th>
                                <th style="width: 5%">Pack ID</th>
                                <th style="width: 5%">Batch</th>
                                <th style="width: 10%">Exp. Date</th>
                                <th style="width: 5%">Qty</th>
                                <th style="width: 5%">UoM</th>
                                <th style="width: 10%">Stock Type</th>
                                <th style="width: 5%">Base Qty</th>
                                <!--<th style="width: 5%">Base UoM</th>-->
                                <!-- <th>Action</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail, index) in data.transport_order_details" :key="index">
                                <td>
                                    <vs-input class="w-full" v-model="detail.line_id" :disabled="true" />
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.warehouse_id" :disabled="disabled_self()" />
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.product_id" :disabled="disabled_self()" />
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.description" :disabled="disabled_self()"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.pack_id" :disabled="disabled_self()"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.batch" :disabled="disabled_self()"/>
                                </td>
                                <td>
                                    <flat-pickr class="w-full" v-model="detail.expired_date" :disabled="disabled_self()"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.qty" :danger="detail.qtyError" @input="convertQty(detail); validateQty(detail)" :disabled="!editMode"/>
                                </td>
                                <td>
                                    <vs-select class="selectExample" v-model="detail.uom_id" width="100%" autocomplete @change="convertQty(detail)" @input="uomChange(detail)" :disabled="disabled_self()">
                                        <vs-select-item v-for="(item, index) in uomOptions" :key="index" :value="item.id" :text="item.name" />
                                    </vs-select>
                                </td>
                                <td>
                                    <vs-select class="selectExample" v-model="detail.stock_type_id" width="100%" autocomplete :disabled="!editMode">
                                        <vs-select-item v-for="(item, index) in stockTypeOptions" :key="index" :value="item.value" :text="item.text" />
                                    </vs-select>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.base_qty" :disabled="!editMode"/>
                                </td>

                                <td>
                                    <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)" :disabled="!editMode" >Remove</vs-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import draggable from 'vuedraggable'

    export default {
        components:{
            vSelect,
            flatPickr,
            draggable,
        },
        props:{
            tro_param_id:{
                type: Number,
                default: false,
                required:true,
            }
        },
        data(){
            return {
                data_old:null,
                old_param_id:0,
                tro_view_id:0,
                editMode: false,
                isLoading: false,
                detailsCount: 0,
                data: {
                    transport_order: {
                        id:0,
                        transport_reference: '',
                        req_del_date: '',
                        order_type_id: null,
                        origin: null,
                        origin_1: null,
                        origin_2: null,
                        origin_area_id: null,
                        origin_subarea_id: null,
                        client_id: null,
                        outbound_id: null,
                        destination: null,
                        destination_1: null,
                        destination_2: null,
                        destination_area_id: null,
                        destination_subarea_id: null,
                        business_type_id: null,
                        is_posted:0,
                        //transport
                        transporter_id: null,
                        service_type_id: null,
                        tracking_reference: '',
                        payment_type_id: null,
                        currency_id: null,
                        order_value: 0,
                        internal_notes: '',
                        external_notes: '',
                        trace_and_tracking: [],
                    },
                    transport_order_details: [],
                },
                clientTypeOptions: [],
                areaOptions: [],
                subAreaOptions: [],
                destAreaOptions: [],
                subDestAreaOptions: [],
                maxRetry: 10,
                orderTypeOptions: [],
                clientOptions: [],
                customerOptions: [],

                selectedId: null,
                productOptions: [],
                warehouseOptions: [],
                stockTypeOptions: [],
                documentLock: [],
                uomOptions:[],
                defaultUom:[],
                  // transport
                serviceTypeOption:[],
                transporterOption:[],
                currencyOption:[],
                paymentTypeOption:[],

            }
        },
        watch: {
            tro_view_id:function(){
                alert('aaaa')
                this.tro_view_id = this.$props.tro_param_id;
                this.fetchAllData();
            },
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            cancelEdit(){
                this.editMode = false
                this.data = Object.assign({},this.data_old) ;
            },
            disabled_self(){
                if(this.editMode == true && this.itsB2c()){
                    return true
                }
                else if(this.editMode == true && !this.itsB2c()){
                    return false
                }
                else if(this.editMode == false && this.itsB2c()){
                    return true
                }
                else if(this.editMode == false && !this.itsB2c()){
                    return true
                }
                  
            },
            itsB2c(){
                let business_type = this.data.transport_order.business_type ;
                if(business_type != null ){
                    if(business_type.code.toLowerCase() == 'b2c' ){
                        return true
                    }
                }else{
                        return false
                }
            },
            fetchData(api) {
                return this.$http.get(api)
            },
            searchArea(search, loading) {
                if(search.length > 3){
                    loading(true)
                    const data = {
                        village: search
                    }
                    this.$http.post('master/get_areas', data)
                    .then(res => {
                        this.areaOptions = res.data.data
                        loading(false)
                    })
                    .catch((error) => {
                        loading(false)
                        console.log(error)
                        // this.searchArea(search, loading)
                    })
                }
            },
            searchSubArea(search, loading) {
                if(search.length > 3){
                    loading(true)
                    const data = {
                        area: search
                    }
                    this.$http.post('master/get_subareas', data)
                    .then(res => {
                        this.subAreaOptions = res.data.data
                        loading(false)
                    })
                    .catch((error) => {
                        loading(false)
                        console.log(error)
                        // this.searchArea(search, loading)
                    })
                }
            },
            searchDestArea(search, loading) {
                if(search.length > 3){
                    loading(true)
                    const data = {
                        area: search
                    }
                    this.$http.post('master/get_areas', data)
                    .then(res => {
                        this.destAreaOptions = res.data.data
                        loading(false)
                    })
                    .catch((error) => {
                        loading(false)
                        console.log(error)
                        // this.searchArea(search, loading)
                    })
                }
            },
            searchDestSubArea(search, loading) {
                if(search.length > 3){
                    loading(true)
                    const data = {
                        area: search
                    }
                    this.$http.post('master/get_subareas', data)
                    .then(res => {
                        this.subDestAreaOptions = res.data.data
                        loading(false)
                    })
                    .catch((error) => {
                        loading(false)
                        console.log(error)
                        // this.searchArea(search, loading)
                    })
                }
            },
            searchTransporter(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        name: search
                    }
                    this.$http.post('master/transporters/filter/search', data)
                    .then(res => {
                        this.clientOption = res.data
                        loading(false)
                    })
                    .catch(() => {
                        this.searchTransporter(search, loading)
                    })
                }
            },
            submitForm() {
                for (let detail of this.data.transport_order_details) {
                    if (!detail.warehouse_id || !detail.product_id || !detail.qty || detail.qty <= 0 || !detail.uom_id || !detail.stock_type_id) {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon: 'icon-x',
                            text: 'Error saving, check line ' + detail.line_id
                        })
                        return false
                    }
                }

                let document_send = {
                    module_id: this.$route.params.id,
                    module_name: 'transport'
                };
                let file = new FormData();
                file.append("file_name", this.file);

                this.isLoading = true

                let header = Object.assign({}, this.data.transport_order);
                header.client_id = header.client_id != null ? header.client_id.id : null;
                header.order_type_id = header.order_type_id != null ? header.order_type_id.id : null;

                const dataSend = {
                    transport_order: JSON.stringify(header),
                    transport_order_details: JSON.stringify(this.data.transport_order_details)
                }

                this.$http.put('transport/transportorder2/' + this.$props.tro_param_id + '/update', dataSend)
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Updated successfully',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        text: 'Transport Order updated'
                    })
                    this.$router.push({
                        name: 'transportorder2'
                    })
                })
                .catch(error => {
                    if (error.response.data.message) {
                        error.response.data.message.map(message => {
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Error saving',
                                iconPack: 'feather',
                                icon: 'icon-x',
                                text: message
                            })
                        })
                    } else {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon: 'icon-x',
                            text: 'Something went wrong'
                        })
                    }
                })
                .then(() => {
                    this.isLoading = false
                })
            },
            back() {
                if(this.editMode) {
                    this.$vs.dialog({
                        color: 'warning',
                        title: 'Leave Page',
                        text: 'Changes you made may not be saved?',
                        acceptText: 'Leave Page',
                        accept: () => this.$router.go(-1),
                    })
                }
                else{
                    this.$router.go(-1)
                }
            },
            fetchAllData() {
                this.isLoading = true
                this.maxRetry = this.maxRetry - 1
                this.$http.all([
                    this.fetchData('transport/transportorder2/' + this.$props.tro_param_id),
                    ])
                .then(this.$http.spread((transport) => {
                    var tsource = transport.data.transportorder
                    var tdata = this.data.transport_order

                    tdata.id = tsource.id
                    tdata.client = tsource.client_code
                    tdata.client_id = tsource.client
                    tdata.transport_reference = tsource.transport_reference
                    tdata.req_del_date = tsource.req_del_date
                    tdata.order_type_id = tsource.order_type
                    tdata.origin = tsource.origin
                    tdata.origin_1 = tsource.origin_address1
                    tdata.origin_2 = tsource.origin_address2
                    tdata.origin_area_id = tsource.origin_area
                    tdata.origin_subarea_id = tsource.origin_subarea
                    tdata.destination = tsource.destination
                    tdata.destination_1 = tsource.destination_address1
                    tdata.destination_2 = tsource.destination_address2
                    tdata.destination_area_id = tsource.destination_area
                    tdata.destination_subarea_id = tsource.destination_subarea

                    this.data.transport_order_details = []

                    this.transporterOption = [tsource.transporter]
                    this.serviceTypeOption = [tsource.service_type]
                    this.paymentTypeOption = [tsource.payment_type]
                    this.orderTypeOptions = [tsource.order_type]
                    this.areaOptions = [tsource.origin_area]
                    this.subAreaOptions = [tsource.origin_subarea]
                    this.destAreaOptions = [tsource.destination_area]
                    this.subDestAreaOptions = [tsource.origin_subarea]

                    this.documentLock = transport.data.locked

                    this.data.transport_order = tdata

                    transport.data.transportorder_details.map(detail => {

                        detail.warehouse_id = detail.warehouse
                        /* if(this.warehouseOptions.length == 0){
                            this.warehouseOptions.push({
                                value: detail.warehouse.id,
                                text: detail.warehouse.name
                            })
                        } */

                        if (this.uomOptions.length == 0) {
                            this.uomOptions.push({
                                value: detail.uom.id,
                                text: detail.uom.name
                            })
                        }
                      
                        if (this.stockTypeOptions.length == 0) {
                            this.stockTypeOptions.push({
                                value: detail.stock_type.id,
                                text: detail.stock_type.name
                            })
                        }

                        detail.data_status = "update"

                        detail.product_id = detail.product
                        /* this.productOptions.push({
                            value: detail.product.id,
                            text: detail.product.product_code,
                        }) */
                        this.data.transport_order_details.push(detail)
                        console.log(this.data.transport_order_details)
                        //this.uomChange(detail)
                    })

                    ////////////////////

                    this.old_param_id = this.$props.tro_param_id
                    this.data_old = Object.assign({},this.data) ;
                    setTimeout(() => {
                        this.isLoading = false
                    }, 500)
                }))
                // .catch(() => {
                //     // if(this.maxRetry < 0){
                //     //     this.isLoading = false
                //     //     this.$vs.dialog({
                //     //         type: 'confirm',
                //     //         color: 'danger',
                //     //         title: 'Server Error',
                //     //         text: 'Try again?',
                //     //         accept: () => {
                //     //             this.fetchAllData()
                //     //             this.maxRetry = 10
                //     //         },
                //     //         cancel: () => this.$router.go(-1),
                //     //         acceptText: 'Yes',
                //     //         cancelText: 'No'
                //     //     })
                //     //     return;
                //     // }
                //     // this.fetchAllData()
                // }))
            },
            removeDetail(index){
                // this.$vs.dialog({
                //     type: 'confirm',
                //     color: 'danger',
                //     title: 'Confirmation',
                //     text: 'Delete this detail?',
                //     accept: () => {
                //         },
                //     acceptText: 'Yes',
                //     cancelText: 'No'
                // })
                this.data.transport_order_details.splice(index, 1)
            },
             addItem() {
                this.detailsCount++
                this.data.transport_order_details.push({
                    line_id: this.detailsCount,
                    warehouse_id: null,
                    product_id: null,
                    description: '',
                    pack_id: '',
                    batch: '',
                    expired_date: null,
                    qty: '',
                    uom_id: null,
                    stock_type_id: this.$store.state.user.userconfig.stock_type_id,
                    committed_qty: 0,
                    base_qty: '',
                    base_uom_id: null,
                    qtyError: false,
                    denominator: 0,
                    numerator: 0,
                })

                this.assignLineId()
            },
            getProduct(detail) {
                this.isLoading = true
                this.maxRetry--
                detail.uom_id = null
                this.fetchData('master/product/' + detail.product_id)
                .then(res => {
                    detail.uomOptions = []
                    detail.defaultUom = []

                    res.data.uoms.map(item => {
                        detail.uomOptions.push({
                            value: item.uom.id,
                            text: item.uom.name,
                            numerator: item.numerator,
                            denominator: item.denominator
                        })
                    })

                    detail.defaultUom.push({
                        value: res.data.default_uom.uom.id,
                        text: res.data.default_uom.uom.name
                    })

                    detail.description = res.data.product.description_1
                    detail.base_uom_id = res.data.default_uom.uom_id
                    detail.uom_id = res.data.default_uom.uom_id
                    this.isLoading = false
                    this.uomChange(detail)
                })
                .catch(() => {
                    if(this.maxRetry <= 0){
                        this.isLoading = false
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Server Error',
                            text: 'Try again?',
                            accept: () => {
                                this.getProduct(detail)
                                this.maxRetry = 10
                            },
                            acceptText: 'Yes',
                            cancelText: 'No'
                        });
                        return;
                    }
                    this.getProduct(detail)
                })
            },
            convertQty(detail){
                //detail.base_qty = (detail.qty / detail.denominator) * detail.numerator
            },
            uomChange(detail) {
                // detail.uomOptions.map(uom => {
                //     if(uom.value == detail.uom_id) {
                //         detail.denominator = uom.denominator
                //         detail.numerator = uom.numerator
                //     }
                // })
            },
            validateQty(detail) {
                if(detail.qty <= 0) {
                    detail.qtyError = true
                }
                else {
                    detail.qtyError = false
                }
            },
            setOrigin() {
                this.fetchData('master/customers/' + this.data.transport_order.origin_id)
                .then(res => {
                    this.data.transport_order.origin_1 = res.data.address_1
                    this.data.transport_order.origin_2 = res.data.address_2
                })
            },
            setDestination() {
                this.fetchData('master/customers/' + this.data.transport_order.destination_id)
                .then(res => {
                    this.data.transport_order.destination_1 = res.data.address_1
                    this.data.transport_order.destination_2 = res.data.address_2
                })
            },
            editForm() {
                if(this.documentLock) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Document Locked',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Data is being processed by ' + this.documentLock.user,
                    })
                }
                else {

                    this.isLoading = true
                    this.maxRetry = this.maxRetry - 1
                    this.warehouseOptions  = [];
                    this.stockTypeOptions = [] ;
                    this.$http.all([
                        this.$http.post('master/clients'),
                        this.$http.post('master/ordertypes'),
                        this.$http.post('master/transporters'),
                        this.$http.post('master/currency'),
                        this.$http.post('master/servicetypes'),
                        this.$http.get('master/paymenttypes'),
                        this.$http.post('master/stocktypes'),
                        this.$http.post('master/uom'),
                    ])

                    .then(this.$http.spread((clients, ordertypes, transporters, currency, servicetypes, paymenttypes, stocktypes, uoms) => {
                        this.clientOptions = clients.data.data
                        this.orderTypeOptions = ordertypes.data.data
                        this.transporterOption = transporters.data.data
                        this.currencyOption = currency.data
                        this.serviceTypeOption = servicetypes.data.data
                        this.paymentTypeOption = paymenttypes.data
                        this.uomOptions = uoms.data.data


                        stocktypes.data.data.map(item => {
                            this.stockTypeOptions.push({
                                value: item.id,
                                text: item.name
                            })
                        })
    
                        setTimeout(() => {
                            this.editMode = true
                            this.isLoading = false
                        }, 500)
                    }))
                    .catch((error) => {
                        if(this.maxRetry < 0){
                            console.log(error)
                            this.isLoading = false
                            this.$vs.dialog({
                                type: 'confirm',
                                color: 'danger',
                                title: 'Server Error',
                                text: 'Try again?',
                                accept: () => {
                                    this.editForm()
                                    this.maxRetry = 10
                                },
                                acceptText: 'Yes',
                                cancelText: 'No'
                            })
                            return;
                        }
                        this.editForm()
                    })
                }
            },
            clientChange() {
                if(this.data.transport_order_details.length > 0) {
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Confirmation',
                        text: 'Changing client will remove details, continue?',
                        accept: () => {
                            this.data.transport_order_details = []
                            this.productOptions = []
                        },
                        acceptText: 'Yes',
                        cancelText: 'No'
                    });
                }
            },
            assignLineId() {
                let lineId = 1
                this.data.transport_order_details.map((detail, index) => {
                    if(detail.data_status != 'delete') {
                        detail.line_id = lineId
                        lineId++
                    }
                })
            }
        },
        updated(){
            if(this.$props.tro_param_id != this.old_param_id && this.$props.tro_param_id != 0){
                this.fetchAllData()
            }
        },
    }
</script>